// Per-language label maps for BirthDetailsForm. Kept as a plain record (not inline
// ternaries) so the component stays simple and adding a label never grows cyclomatic
// complexity. Hindi is native Hinglish (Roman) — the verified brand register (rule 21:
// single Indian noun + English action word; pure Devanagari compounds score 0) — matching
// the Hinglish error copy on the same entry surfaces (/ai-astrologer, /free-astrology-chat,
// /free-kundali) where the plan's mobile form-failure classes concentrate. Guarded by
// scripts/check_hindi_register.py (no Devanagari U+0900–U+097F in the hi block).

export const BIRTH_FORM_LABELS = {
  en: {
    yourName: "Your Name",
    enterFullName: "Enter your full name",
    namePlaceholderOptional: "Name (optional)",
    birthDate: "Birth Date",
    birthTime: "Birth Time",
    required: "(required)",
    optional: "(optional)",
    timeRequiredHint: "Ascendant changes every ~2 hours — accurate time is essential.",
    timeOptionalHint: "Skip if unknown. Lagna-based insights need exact time.",
    timeUnknownToggle: "Don't know your birth time?",
    timeUnknownExplainer:
      "No problem — we'll read the planets with a noon default, which holds true for your rashi and nakshatra. One honest note: your Lagna, houses, and dasha cannot be read without the exact time.",
    birthPlace: "Birth Place",
    changePlace: "Change",
    pickCityHint: "Pick a city from the suggestions for precise coordinates.",
    calculating: "Calculating...",
    yearTooEarly: "Year must be 1900 or later.",
    futureDate: "Birth date cannot be in the future.",
    defaultSubmit: "Calculate",
  },
  hi: {
    yourName: "Aapka naam",
    enterFullName: "Apna pura naam likhein",
    namePlaceholderOptional: "Naam (optional)",
    birthDate: "Janm tithi",
    birthTime: "Janm samay",
    required: "(required)",
    optional: "(optional)",
    timeRequiredHint: "Lagna har ~2 ghante mein badalta hai — sahi samay zaroori hai.",
    timeOptionalHint: "Pata na ho to skip karein. Lagna-based insight ke liye sahi samay chahiye.",
    timeUnknownToggle: "Janm samay nahi pata?",
    timeUnknownExplainer:
      "Koi baat nahi — hum dopahar 12 baje maankar graha sthiti nikaal denge, jo rashi aur nakshatra ke liye sahi rehti hai. Par dhyaan rahe: Lagna, bhaav aur dasha sahi janm samay ke bina nahi bataye ja sakte.",
    birthPlace: "Janm sthal",
    changePlace: "Badlein",
    pickCityHint: "Sahi coordinates ke liye suggestions mein se sheher chunein.",
    calculating: "Calculate ho raha hai...",
    yearTooEarly: "Saal 1900 ya uske baad ka hona chahiye.",
    futureDate: "Janm tithi future ki nahi ho sakti.",
    defaultSubmit: "Calculate karein",
  },
} as const;

export function birthFormLabels(language: "en" | "hi") {
  return BIRTH_FORM_LABELS[language];
}
